import React from 'react';
import Modal from 'react-bootstrap/Modal';
import withTranslations from '../../utils/HighOrderComponent';
import ComplementRequestHistoryTable from './ProcessingView.js/ComplementRequestHistoryTable';

class ModalForViewComplementRequestHistory extends React.Component {
  handleClose = () => {
    this.props.handleClose();
  };

  render() {
    const { t, complementRequestApprovalList } = this.props || {},
      { Labels } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="wide-modal second-modal"
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <ComplementRequestHistoryTable
                    complementRequestApprovalList={
                      complementRequestApprovalList
                    }
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForViewComplementRequestHistory,
  'ModalForViewComplementRequestHistory'
);
